import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import vClickOutside from "click-outside-vue3"
import './styles/tailwind.css'
import 'vue-multiselect/dist/vue-multiselect.css'

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

import 'moment-timezone';

import { library } from '@fortawesome/fontawesome-svg-core'
import { 
    faBell,
    faChevronDown,
    faGear,
    faMoon,
    faSortDown,
    faSun,
    faHome,
    faMapLocationDot,
    faChevronRight,
    faTrash,
    faPencil,
    faGears,
    faBriefcase,
    faWarehouse,
    faTruckRampBox,
    faPlus,
    faTriangleExclamation,
    faLocationPin,
    faPrint,
    faBan,
    faBoxesPacking,
    faEye,
    faEyeSlash,
    faFileInvoice,
    faCheck,
    faUserSecret,
    faCheckSquare,
    faLock,
    faLockOpen,
    faBuilding,
    faFolderTree
} from '@fortawesome/free-solid-svg-icons'

import { faSquare } from '@fortawesome/free-regular-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
    faChevronDown,
    faSortDown,
    faBell,
    faGear,
    faMoon,
    faSun,
    faHome,
    faMapLocationDot,
    faChevronRight,
    faTrash,
    faPencil,
    faGears,
    faBriefcase,
    faWarehouse,
    faTruckRampBox,
    faPlus,
    faTriangleExclamation,
    faLocationPin,
    faPrint,
    faBan,
    faBoxesPacking,
    faEye,
    faEyeSlash,
    faFileInvoice,
    faCheck,
    faUserSecret,
    faSquare,
    faCheckSquare,
    faLock,
    faLockOpen,
    faBuilding,
    faFolderTree
)

createApp(App)
.use(store)
.use(router)
.use(vClickOutside)
.use(VueSweetalert2)
.component('font-awesome-icon', FontAwesomeIcon)
.component('VueDatePicker', VueDatePicker)
.mount('#app')
